import type ReferenceInterface from "./base";

export interface CountryInterface extends ReferenceInterface {}

export const COUNTRY_CODE_FRA = "FRA";
